
/// <amd-module name="TFS/Token/PatTokenPage/Models/TokenConfig" />
import { PatTokenPageData } from 'Generated/Contracts';
import { IVssPageContext } from 'VSS/Platform/Context';
import { IVssContributionService } from 'VSS/Platform/Contribution';
import { IPageData, IVssPageService } from 'VSS/Platform/Page';
import { traceException } from "VSS/Platform/Trace";
import { IQueryParameter, Uri } from 'VSS/Platform/Util/Url';

export class TokenConfig  {
    public tokenPageData: PatTokenPageData;
    public hostPageData: IPageData | undefined;
    public searchParams: IQueryParameter[];
    private static readonly tokenDataProviderContributionId = "ms.vss-token-web.personal-access-token-page-data-provider";
    public static getInstance(pageContext: IVssPageContext): TokenConfig {
        if (!this._instance) {
            this._instance = new TokenConfig(pageContext);
        }
        return this._instance;
    }

    public static setInstance(pageContext: IVssPageContext, tokenPageDAta: PatTokenPageData) {
        this._instance = new TokenConfig(pageContext, tokenPageDAta);
    }

    constructor(pageContext: IVssPageContext, tokenPageData?: PatTokenPageData, hostPageData?: IPageData) {
        this.tokenPageData = tokenPageData || this.getTokenPageData(pageContext);
        this.hostPageData = hostPageData || this.getHostPageData(pageContext);
        this.searchParams = this.getUrlSearchparams();
    }

    private getTokenPageData(pageContext: IVssPageContext): PatTokenPageData {
        let calculatedTokenPageData: PatTokenPageData | undefined;
        try {
            const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
            calculatedTokenPageData = contributionService.getData(TokenConfig.tokenDataProviderContributionId) as PatTokenPageData;
        } catch (ex) {
            traceException(pageContext, TokenConfig.toString(), "pageDataContribution", ex);
        }

        // Adding for backwards compatibility since previous version of the data provider returns (bool? bool? int?) and the client expects (bool, bool, bool, int)
        // in each case, undefined or null means the userCan** = true
        if (calculatedTokenPageData !== undefined) {
            if (calculatedTokenPageData.userCanCreateGlobalTokens === undefined || calculatedTokenPageData.userCanCreateGlobalTokens === null) {
                calculatedTokenPageData.userCanCreateGlobalTokens = true;
            }

            if (calculatedTokenPageData.userCanCreateFullScopedTokens === undefined || calculatedTokenPageData.userCanCreateFullScopedTokens === null) {
                calculatedTokenPageData.userCanCreateFullScopedTokens = true;
            }

            // if userCanCreateUnlimitedLifespanTokens is not defined, base its value on userTokenLifespanLimitInDays
            if (calculatedTokenPageData.userCanCreateUnlimitedLifespanTokens === undefined || calculatedTokenPageData.userCanCreateUnlimitedLifespanTokens === null) {
                calculatedTokenPageData.userCanCreateUnlimitedLifespanTokens =
                    (calculatedTokenPageData.userTokenLifespanLimitInDays === undefined || calculatedTokenPageData.userTokenLifespanLimitInDays === null);
            }
        }

        return calculatedTokenPageData || {
            aadTenantName: "",
            coreScopeGroupings: [],
            getTokenPageSize: 100,
            scopes: {},
            userCanCreateGlobalTokens: true,
            userCanCreateFullScopedTokens: true,
            userCanCreateUnlimitedLifespanTokens: true,
            userTokenLifespanLimitInDays : 0
        };
    }

    private getHostPageData(pageContext: IVssPageContext): IPageData | undefined {
        const pageService = pageContext.getService<IVssPageService>("IVssPageService");
        return pageService.getData();
    }

    private getUrlSearchparams(): IQueryParameter[] {
        const url = new Uri(window.location.href);
        const searchParams = url.queryParameters;
        return searchParams;
    }

    public getParamValueFromSearchParams(paramToFind: string): string | undefined {
        const param = this.searchParams.find(param => param.name === paramToFind);
        if(param && param.value) {
            return param.value;
        }
    }

    private static _instance: TokenConfig;
}
